module.exports = __webpack_public_path__ + "media/哈欠.73b7f4f9.wav";